import { useOfferPageContext } from "@circle-react/components/Paywalls/CheckoutWithSession/pages/OfferPage/OfferPageProvider";
import type { PropsWithChildren } from "react";

import { PricePreviewContext } from "./";

export const OfferPricePreviewContext = ({
  children,
}: PropsWithChildren<unknown>) => (
  <PricePreviewContext useHooks={useOfferPageContext}>
    {children}
  </PricePreviewContext>
);
